import React from "react";
import { Row, Col, Label, Input, FormGroup } from "reactstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import { AddCommaNumber } from "../../../helpers/Utils";
import PriceInput from "../../../components/common/PriceInput";
import { Colxx } from "../../../components/common/CustomBootstrap";

const ContentComponent = (props) => {
  return !props.values || !props.values.length ? (
    <>
      <AddMoreButton onAdd={() => props.onAdd()} disabled={props.disabled} />
    </>
  ) : (
    <>
      {props.values.map((item, idx) => (
        <TimerComponent
          key={idx}
          item={item}
          name={props.name}
          onChange={props.onChange}
          onRemove={props.onRemove}
          disabled={props.disabled}
        />
      ))}
      <AddMoreButton onAdd={() => props.onAdd()} disabled={props.disabled} />
    </>
  );
};

const TimerComponent = (props) => {
  return (
    <Row className="product-add-option-row mb-3 mt-3 no-gutters">
      <Colxx xxs={4} xs={4} sm={4} md={4} lg={4} className="pr-1">
        <FormGroup className="product-add-option-field mb-0">
          <Label for="product.name">
            <IntlMessages id="product.add.name" />
          </Label>
          <Input
            value={props.item.name}
            id="name"
            placeholder={
              props.name === "topping"
                ? "Nhập tên topping"
                : props.name === "flavor"
                  ? "Nhập tên vị"
                  : "Nhập tên size"
            }
            onChange={(event) =>
              props.onChange(
                event.target.value,
                props.name,
                props.item.id,
                "name",
              )
            }
            disabled={props.disabled}
          />
        </FormGroup>
      </Colxx>
      <Colxx xxs={3} xs={3} sm={3} md={3} lg={3} className="pr-1">
        <FormGroup className="product-add-option-field mb-0">
          <Label for="product.value">
            {props.name === "topping" || props.name === "flavor" ? (
              "Giá thêm"
            ) : props.name === "color" ? (
              "Giá bán"
            ) : (
              <IntlMessages id="product.add.value" />
            )}
          </Label>
          <PriceInput
            id="value"
            value={props.item.value}
            placeholder={
              props.name === "topping" || props.name === "flavor"
                ? "Nhập giá thêm"
                : "Nhập giá trị"
            }
            onChange={(val) =>
              props.onChange(
                val,
                props.name,
                props.item.id,
                "value",
              )
            }
            disabled={props.disabled}
          />
        </FormGroup>
      </Colxx>
      <Colxx xxs={3} xs={3} sm={3} md={3} lg={3} className="pr-0">
        <FormGroup className="product-add-option-field mb-0">
          <Label for="product.promo_price">Giá KM</Label>
          <PriceInput
            id="promo_price"
            value={props.item.promo_price}
            placeholder="Nhập giá khuyến mãi"
            onChange={(val) =>
              props.onChange(
                val,
                props.name,
                props.item.id,
                "promo_price",
              )
            }
            disabled={props.disabled}
          />
        </FormGroup>
      </Colxx>
      <Colxx
        xxs={2}
        xs={2}
        sm={2}
        md={2}
        lg={2}
        className="product-add-option-remove pl-1 text-center"
      >
        {props.disabled ? (
          <span className="d-inline-block" style={{ width: 28, height: 28 }} />
        ) : (
          <span
            className="working_hours_btn disable-text-selection"
            onClick={() => props.onRemove(props.name, props.item.id)}
          >
            -
          </span>
        )}
      </Colxx>
    </Row>
  );
};

const AddMoreButton = (props) => {
  return (
    <Row className="mt-3">
      <Col sm={12} xs={12} md={12} lg={12}>
        <span
          className="working_hours_btn working_hours_btn-zero-top mb-3 disable-text-selection"
          onClick={props.disabled ? null : props.onAdd}
        >
          +
        </span>
      </Col>
    </Row>
  );
};

export default ContentComponent;
